enum AnswerType {
  Standard = 'Standard',
  NA = 'NA',
  ParticipantDefined = 'ParticipantDefined',
}
export default AnswerType;

export const getAnswerTypeText = (type: AnswerType) => {
  switch (type) {
    case AnswerType.Standard:
      return 'Standart';
    case AnswerType.NA:
      return 'Not Applicable';
    case AnswerType.ParticipantDefined:
      return 'Participant Defined';
    default:
      throw Error(`Unknown AnswerType (${type})`);
  }
};
